module.exports = __webpack_public_path__ + "static/media/oleg_severe_right.6689fcde.png";